function StateChange($rootScope, $state, jsSdkAuthService, tlAuthService, $timeout, $window) {
  $rootScope.$on('$stateChangeSuccess', (fromState, toState) => {
    if (!fromState) return;

    if (toState.scrollToTop === false) {
      return;
    }

    $timeout(function() {
      $window.scrollTo(0, 0);
    }, 100);
  });

  $rootScope.$on('unauthorized', () => {
    jsSdkAuthService.logout();
    tlAuthService.logout();

    $state.go('app.login');
  });
}

StateChange.$inject = [
  '$rootScope',
  '$state',
  'jsSdk.auth',
  'tl.auth.service',
  '$timeout',
  '$window'
];

export default StateChange;



// WEBPACK FOOTER //
// ./src/stateChange.js